module.exports = __webpack_public_path__ + "static/glorious_5-eaaa6d5ebeaca1650660c24b3cda8b39.jpg";